/**
 * Injects JSON-LD structured data into <head>. Rich snippets friendly.
 * Renders nothing visible. Cleans up on unmount to keep <head> tidy.
 */
import { useEffect } from "react";

export default function JsonLd({ data, id = "jsonld" }) {
  useEffect(() => {
    if (!data) return undefined;
    const scripts = (Array.isArray(data) ? data : [data])
      .filter(Boolean)
      .map((payload, i) => {
        const el = document.createElement("script");
        el.type = "application/ld+json";
        el.setAttribute("data-jsonld-id", `${id}-${i}`);
        el.textContent = JSON.stringify(payload);
        document.head.appendChild(el);
        return el;
      });
    return () => scripts.forEach((el) => el.remove());
  }, [data, id]);

  return null;
}
